import React, { FC } from 'react';
import { Box, Theme } from '@material-ui/core';
import Link from 'next/link';
import {
  ConstructionIcon,
  EnergyIcon,
  EngineeringIcon,
  PentagonConstructionIcon,
  PentagonEnergyIcon,
  PentagonEngineeringIcon,
  PentagonLogoIcon,
  PentagonTechnologyDeploymentIcon,
  PentagonWirelessIcon,
  TechnologyDeploymentIcon,
  WirelessIcon,
} from 'svgs/about-us';
import { createStyles, makeStyles } from '@material-ui/styles';

interface HistoryComponentProps {
  energyLink: string;
  technologyDeploymentLink: string;
  constructionLink: string;
  wirelessLink: string;
  engineeringLink: string;
}

const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    box1: {
      bottom: theme.spacing(-16),
      left: theme.spacing(4),
    },
    box2: {
      top: theme.spacing(-15),
      left: theme.spacing(-5),
    },
    box3: {
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -193%)',
    },
    box4: {
      top: theme.spacing(-13.4),
      right: theme.spacing(-1.7),
    },
    box5: {
      bottom: theme.spacing(-17.6),
      right: 0,
    },
    boxIcons: {
      position: 'relative',
      cursor: 'pointer',
      '&:hover': {
        '& svg': {
          '& path': {
            fill: theme.palette.primary.main,
          },
        },
        '& div': {
          '& svg': {
            '& path': {
              fill: theme.palette.common.white,
            },
          },
        },
      },
    },
    icon1: {
      position: 'absolute',
      top: theme.spacing(5),
      left: theme.spacing(8),
    },
    icon2: {
      position: 'absolute',
      top: theme.spacing(9),
      left: theme.spacing(11.5),
    },
    icon3: {
      position: 'absolute',
      top: theme.spacing(7),
      left: theme.spacing(8),
    },
    icon4: {
      position: 'absolute',
      top: theme.spacing(7),
      left: theme.spacing(9.7),
    },
    icon5: {
      position: 'absolute',
      top: theme.spacing(7),
      left: theme.spacing(10.8),
    },
  });
});

const HistoryComponent: FC<HistoryComponentProps> = ({
  energyLink,
  technologyDeploymentLink,
  constructionLink,
  wirelessLink,
  engineeringLink,
}) => {
  const classes = useStyles();
  return (
    <Box display="flex" justifyContent="center" position="relative" mt={24}>
      <Box position="absolute" className={classes.box1}>
        <Link href={energyLink} passHref>
          <Box className={classes.boxIcons}>
            <PentagonEnergyIcon />
            <Box className={classes.icon1}>
              <EnergyIcon />
            </Box>
          </Box>
        </Link>
      </Box>
      <Box position="absolute" className={classes.box2}>
        <Link href={technologyDeploymentLink} passHref>
          <Box className={classes.boxIcons}>
            <PentagonTechnologyDeploymentIcon />
            <Box className={classes.icon2}>
              <TechnologyDeploymentIcon />
            </Box>
          </Box>
        </Link>
      </Box>
      <Box position="absolute" className={classes.box3}>
        <Link href={constructionLink} passHref>
          <Box className={classes.boxIcons}>
            <PentagonConstructionIcon />
            <Box className={classes.icon3}>
              <ConstructionIcon />
            </Box>
          </Box>
        </Link>
      </Box>
      <Box display="flex" justifyContent="center">
        <PentagonLogoIcon />
      </Box>
      <Box position="absolute" className={classes.box4}>
        <Link href={wirelessLink} passHref>
          <Box className={classes.boxIcons}>
            <PentagonWirelessIcon />
            <Box className={classes.icon4}>
              <WirelessIcon />
            </Box>
          </Box>
        </Link>
      </Box>
      <Box position="absolute" className={classes.box5}>
        <Link href={engineeringLink} passHref>
          <Box className={classes.boxIcons}>
            <PentagonEngineeringIcon />
            <Box className={classes.icon5}>
              <EngineeringIcon />
            </Box>
          </Box>
        </Link>
      </Box>
    </Box>
  );
};

export default HistoryComponent;
